import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD6xyiOCvGS1pZIcGu3AD2sDaDPF036XuI",
  authDomain: "slavex-b829c.firebaseapp.com",
  projectId: "slavex-b829c",
  storageBucket: "slavex-b829c.firebasestorage.app",
  messagingSenderId: "340481947694",
  appId: "1:340481947694:web:8e7bd537a2edb93a1147bf",
  measurementId: "G-YCY1YWXKJX"
};

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
  throw new Error(`Firebase initialization failed: ${error.message}`);
}

// Initialize Firebase services
export const auth = getAuth(app);

// Set authentication persistence to localStorage
// This means users will stay logged in across browser tabs and sessions
// However, we enforce an 8-hour timeout for security
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // console.log('Firebase Auth persistence set to localStorage');
  })
  .catch((error) => {
    console.error('Error setting Firebase Auth persistence:', error);
  });

export const db = getFirestore(app);
export const storage = getStorage(app);
// Initialize Analytics only when supported and measurementId exists
let analyticsInstance = null;
try {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && firebaseConfig.measurementId) {
    analyticsInstance = getAnalytics(app);
  }
} catch (e) {
  console.warn('Firebase Analytics not initialized:', e);
}
export const analytics = analyticsInstance;

export default app;
